import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { CalendarHeart, User, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { MaintenancePage, useMaintenanceMode } from "../../lib/maintenance";

const CLIENT_NAV = [
  { to: "/compte", label: "Mes événements", icon: CalendarHeart, end: true },
  { to: "/compte/profil", label: "Mes informations", icon: User },
];

export const ClientLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const maintenance = useMaintenanceMode();
  if (maintenance) return <MaintenancePage />;
  return (
  <div className="container-ae py-10 md:py-14" data-testid="client-space">
    <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
      <div>
        <p className="overline-ae mb-2">Espace client</p>
        <h1 className="text-3xl sm:text-4xl text-deepgreen">Mon espace</h1>
        {user && <p className="mt-1 text-sm text-muted-foreground" data-testid="client-user-email">{user.first_name} {user.last_name} — {user.email}</p>}
      </div>
      <button type="button" onClick={async () => { await logout(); navigate("/"); }} className="btn-secondary-ae !px-5 !py-2.5 !text-xs" data-testid="client-logout">
        <LogOut className="h-4 w-4" /> Me déconnecter
      </button>
    </div>
    <div className="mb-8 flex gap-2 overflow-x-auto border-b border-border">
      {CLIENT_NAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          data-testid={`client-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          className={({ isActive }) =>
            `flex items-center gap-2 whitespace-nowrap border-b-2 px-4 py-3 text-sm font-semibold transition-colors ${
              isActive ? "border-deepgreen text-deepgreen" : "border-transparent text-muted-foreground hover:text-deepgreen"
            }`
          }
        >
          <item.icon className="h-4 w-4" />
          {item.label}
        </NavLink>
      ))}
    </div>
      <Outlet />
  </div>
  );
};